import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import handlesJobAndBursaryFilters from "~/mixins/handlesJobAndBursaryFilters";
import { mapGetters } from 'vuex';
export default {
  name: 'JobsSidebarList',
  mixins: [handlesJobAndBursaryFilters],
  setup: function setup() {
    var loading = ref(false);
    var loadingMore = ref(false);
    var currentScrollPosition = ref(0);
    return {
      loading: loading,
      loadingMore: loadingMore,
      currentScrollPosition: currentScrollPosition
    };
  },
  props: {
    favourites: {
      default: 'all',
      required: false,
      type: String
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters('jobs', {
    jobs: 'getFilteredJobs',
    scrollPosition: 'getScrollPosition'
  })), mapGetters('jobs/single', {
    job: 'getJobSingle'
  })), {}, {
    filteredJobs: function filteredJobs() {
      var _this$jobs;

      return ((_this$jobs = this.jobs) === null || _this$jobs === void 0 ? void 0 : _this$jobs.data) || null;
    }
  }),
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getFilteredJobs();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getFilteredJobs: function getFilteredJobs() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return _this2.resetFilters();

              case 3:
                _context2.next = 5;
                return _this2.resetCursor();

              case 5:
                _context2.next = 7;
                return _this2.$store.dispatch('jobs/getFilteredJobs').then(function () {
                  _this2.loading = false;
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    loadMoreJobs: function loadMoreJobs(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight && _this3.jobs.meta.next_cursor)) {
                  _context3.next = 6;
                  break;
                }

                _this3.loadingMore = true;
                _context3.next = 4;
                return _this3.$store.dispatch('jobs/setCursor', _this3.jobs.meta.next_cursor);

              case 4:
                _context3.next = 6;
                return _this3.$store.dispatch('jobs/getFilteredJobs').then(function () {
                  _this3.loadingMore = false;
                });

              case 6:
                _this3.currentScrollPosition = e.target.scrollTop;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    jobClicked: function jobClicked() {
      this.$store.dispatch('jobs/setScrollPosition', this.currentScrollPosition / 3 - 200);
    },
    goToTop: function goToTop() {
      this.$refs.jobList.scrollTop = 0;
    }
  }
};